import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getCookies = ({ name }) => cookies.get(name);
export const setCookies = ({ name, value, options = {} }) => cookies.set(name, value, options);

// Ensure cookies are removed with the same options (path) used when setting them.
// By default we use path: '/' to match the login cookie.
export const removeCookies = ({ name, options = { path: '/' } }) =>
  cookies.remove(name, options);

